import React, { useState, useEffect } from "react";
import MultiSelect, { Option } from "../InputComponents/Filters/MultiSelect";

interface QuestionnaireFilterProps {
  onFiltersChange: (filters: QuestionnaireFilters) => void;
  nameOptions: Option[];
  typeOptions: Option[];
  projectNumberOptions: Option[];
  projectOfficerOptions: Option[];
  className?: string;
}

interface QuestionnaireFilters {
  names: string[];
  types: string[];
  projectNumbers: string[];
  projectOfficers: string[];
}

const QuestionnaireFilter: React.FC<QuestionnaireFilterProps> = ({
  onFiltersChange,
  nameOptions,
  typeOptions,
  projectNumberOptions,
  projectOfficerOptions,
  className = ""
}) => {
  // État local pour stocker les filtres sélectionnés
  const [filtersVisible, setFiltersVisible] = useState(true);
  const [selectedNames, setSelectedNames] = useState<string[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [selectedProjectNumbers, setSelectedProjectNumbers] = useState<string[]>([]);
  const [selectedProjectOfficers, setSelectedProjectOfficers] = useState<string[]>([]);

  useEffect(() => {
    onFiltersChange({
      names: selectedNames,
      types: selectedTypes,
      projectNumbers: selectedProjectNumbers,
      projectOfficers: selectedProjectOfficers
    });
  }, [selectedNames, selectedTypes, selectedProjectNumbers, selectedProjectOfficers, onFiltersChange]);

  // Handlers pour les sélections
  const handleNameSelectionChange = (values: string[]) => {
    console.log("Selected names:", values);
    setSelectedNames(values);
  };

  const handleTypeSelectionChange = (values: string[]) => {
    console.log("Selected types:", values);
    setSelectedTypes(values);
  };

  const handleProjectNumberSelectionChange = (values: string[]) => {
    console.log("Selected project numbers:", values);
    setSelectedProjectNumbers(values);
  };

  const handleProjectOfficerSelectionChange = (values: string[]) => {
    console.log("Selected project officers:", values);
    setSelectedProjectOfficers(values);
  };

  // Custom CSS style injecté pour assurer la consistance des polices
  const injectCss = `
    .custom-form-control,
    .custom-form-select,
    .custom-form-select option {
      height: 60px !important;
      font-size: 19px !important;
      font-family: inherit !important;
    }
  `;

  // Style pour le bouton de basculement des filtres
  const buttonStyle = {
    fontSize: "14px",
    fontWeight: 400,
    padding: "4px 8px",
    color: "#6c757d",
    textDecoration: "none",
    border: "none",
    background: "none"
  };

  return (
    <div className={`mt-4 mb-4 ${className}`}>
      {/* Custom CSS injection */}
      <style>{injectCss}</style>
      
      {/* Bouton pour masquer/afficher les filtres */}
      <div className="d-flex justify-content-end mb-2">
        <button 
          onClick={() => setFiltersVisible(!filtersVisible)}
          className="btn btn-sm text-secondary"
          style={buttonStyle}
        >
          {filtersVisible ? "Hide filters" : "Show filters"}
        </button>
      </div>

      {/* Filtres - conditionnellement visibles */}
      {filtersVisible && (
        <div className="row g-2 mb-2">
        <div className="col-md-3">
          <MultiSelect
            options={typeOptions}
            initialValue={selectedTypes}
            onSelectionChange={handleTypeSelectionChange}
            placeholder="Filter by Programme"
            className="w-100"
          />
        </div>
          <div className="col-md-3">
            <MultiSelect
              options={nameOptions}
              initialValue={selectedNames}
              onSelectionChange={handleNameSelectionChange}
              placeholder="Filter by Project acronym"
              className="w-100"
            />
          </div>
          <div className="col-md-3">
            <MultiSelect
              options={projectNumberOptions}
              initialValue={selectedProjectNumbers}
              onSelectionChange={handleProjectNumberSelectionChange}
              placeholder="Filter by Project number"
              className="w-100"
            />
          </div>
          <div className="col-md-3">
            <MultiSelect
              options={projectOfficerOptions}
              initialValue={selectedProjectOfficers}
              onSelectionChange={handleProjectOfficerSelectionChange}
              placeholder="Filter by Project officer"
              className="w-100"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionnaireFilter;